import React, { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import {
	SubscriptionApi,
	UpdateSubscriptionsApi,
} from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { PriceConfiguratorContentApi, PriceConfiguratorPlanApi } from "../../../../../../../../services/Api/types";
import { splitDateWithComma } from "../Preview/SingleSubscriptionPreview";
import UninstalledSubscription from "./components/UninstalledSubscription";

interface Props {
	original?: SubscriptionApi;
	form: UseFormReturn<UpdateSubscriptionsApi>;
	index: number;
	onResume: () => void;
	editable: boolean;
	config: PriceConfiguratorContentApi;
	plan?: PriceConfiguratorPlanApi;
}

const CancelledSubscription: FC<Props> = (props: Props) => {
	const { watch } = props.form;
	const { t } = useTranslation();
	const watchedStatus = watch(`subscriptions.${props.index}.status`);
	const watchedCancellationReason = watch(`subscriptions.${props.index}.cancellation_reason`);
	const watchedReasonDetails = watch(`subscriptions.${props.index}.reason_details`);
	const watchedScheduledCancellationAt = watch(`subscriptions.${props.index}.scheduled_cancellation_at`);

	if (!props.plan) {
		return <>READONLY</>;
	}
	const isEditable = props.plan.edit_mode === "EDITABLE";

	const getTootlipContent = () => {
		if (!watchedCancellationReason && !watchedReasonDetails) return undefined;
		let text = "";
		if (watchedCancellationReason) {
			text += t(`constraints.SUBSCRIPTION_${watchedCancellationReason}`);
		}
		if (watchedReasonDetails) {
			text += ` (${watchedReasonDetails})`;
		}
		return text;
	};
	const getDate = () => {
		let date = "";
		let transText = "";
		if (watchedScheduledCancellationAt) {
			date = FormatDate(watchedScheduledCancellationAt);
		} else if (props.original) {
			if (props.original.current_term_end) {
				date = FormatDate(props.original.current_term_end);
			} else if (props.original.trial_end) {
				date = FormatDate(props.original.trial_end);
			} else if (props.original.cancelled_at) {
				transText = t("modules.subscription.field.expired.title");
				date = FormatDate(props.original.cancelled_at);
			}
		}
		if (!date) return undefined;
		return `${transText} ${splitDateWithComma(date)}`;
	};

	return (
		<UninstalledSubscription
			familyId={props.config.family_id}
			planName={props.plan.name}
			planDescription={props.plan.description}
			editable={isEditable}
			status={watchedStatus}
			date={getDate()}
			handleResume={props.onResume}
			toolTipContent={getTootlipContent()}
		/>
	);
};

export default CancelledSubscription;
